import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'services/store';

const useGetSiteControlUserParams = (): void => {
  const user = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (!user.subscriptionType) return;

    (window as Window).gsc('params', {
      subscriptionType: user.subscriptionType,
      hasDistribution: user.hasDistribution?.toString(), // GSC doesn't accept boolean, only strings.
    });
  }, [user]);
};

export default useGetSiteControlUserParams;
